import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IRuleTag, ITaggedRule } from '../../data-rules-model';

@Injectable({
  providedIn: 'root'
})
export class DataRulesTagService {
  constructor(private http: HttpClient) {
  }

  getAllTags(): Observable<IRuleTag[]> {
    return this.http.get<IRuleTag[]>(`${environment.dataRulesUrl}/tag/`);
  }

  getAllTaggedRules(): Observable<ITaggedRule[]> {
    return this.http.get<ITaggedRule[]>(`${environment.dataRulesUrl}/tag/rule`);
  }

  createTag(name: string): Observable<IRuleTag> {
    return this.http.post<IRuleTag>(`${environment.dataRulesUrl}/tag/`, { name });
  }

  updateTag(tag: IRuleTag): Observable<IRuleTag> {
    return this.http.put<IRuleTag>(`${environment.dataRulesUrl}/tag/${tag.id}`, tag);
  }

  tagRule(tagId: string, ruleId: string): Observable<any> {
    return this.http.post<any>(`${environment.dataRulesUrl}/tag/${tagId}/rule/${ruleId}`, {});
  }

  deleteTag(tagId: string): Observable<any> {
    return this.http.delete<any>(`${environment.dataRulesUrl}/tag/${tagId}`);
  }

  deleteTaggedRule(tagId: string, ruleId: string): Observable<any> {
    return this.http.delete<any>(`${environment.dataRulesUrl}/tag/${tagId}/rule/${ruleId}`);
  }
}
